<div *ngIf="showTooltip" [appUserInfoTooltip]="user?.id" class="user-render-info"> {{ getUserFields() }} </div>
<div *ngIf="!showTooltip" class="user-render-info"> {{ getUserFields() }} </div>
